<!-- <div class="dialog-container">
  <div class="dialog-header">
    <div class="user-edit-icon">
      <img src="assets/images/user-circle.png" class="dialog-icon" alt="User Icon" />
    </div>
    <h2 class="dialog-title">Edit Health Info</h2>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="healthForm" class="dialog-form">
    <div class="form-row">
      <mat-form-field appearance="outline" step="0.01" class="half-width">
        <mat-label>Height ({{height}}) </mat-label>
        <input matInput type="number" min="0" formControlName="height" (input)="onNumberInput($event, 'height')"/>
         <mat-error *ngIf="getError('height') as err">{{ err }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="dropdown-width">
        <mat-label>Unit</mat-label>
        <mat-select formControlName="heightUnit">
          <mat-option value="cm">cm</mat-option>
          <mat-option value="inch">inch</mat-option>
          <mat-option value="feet">feet</mat-option>
        </mat-select>
      </mat-form-field>
      </div>
      <div class="form-row">

      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Weight ({{weight }}) </mat-label>
        <input matInput type="number" step="0.01" min="0" formControlName="weight" (input)="onNumberInput($event, 'weight')"/>
         <mat-error *ngIf="getError('weight') as err">{{ err }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="dropdown-width">
        <mat-label>Unit</mat-label>
        <mat-select formControlName="weigthtUnit">
          <mat-option value="kg">kg</mat-option>
          <mat-option value="lbs">lbs</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Blood Group </mat-label>
      <mat-select formControlName="bloodGroup">
        <mat-option *ngFor="let group of bloodGroups" [value]="group.title">{{ group.title }}</mat-option>
      </mat-select>
      <mat-error *ngIf="getError('bloodGroup') as err">{{ err }}</mat-error>
    </mat-form-field>
    <div class="form-row">
      <mat-form-field appearance="outline" class="half-width">
       <mat-label>Date Of Birth</mat-label>
        <input matInput [matDatepicker]="picker" [max]="maxDate" formControlName="dob" required readonly (click)="picker.open()"/>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="getError('dob') as err">{{ err }}</mat-error>
      </mat-form-field>
    <mat-form-field appearance="outline" class="half-width">
         <mat-label>Gender</mat-label>
      <mat-select formControlName="gender">
        <mat-option *ngFor="let option of gender_list" [value]="option">{{ option }}</mat-option>
      </mat-select>
      <mat-error *ngIf="getError('gender') as err">{{ err }}</mat-error>
      </mat-form-field>
    </div>
    

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Ethnicity</mat-label>
      <mat-select formControlName="ethnicity">
        <mat-option *ngFor="let option of ethnicities" [value]="option.title">{{ option.title }}</mat-option>
      </mat-select>
      <mat-error *ngIf="getError('ethnicity') as err">{{ err }}</mat-error>
    </mat-form-field>

    <div class="dialog-actions">
      <button mat-stroked-button color="primary" (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary" (click)="onSave()">Save</button>
    </div>
  </form>
</div> -->

<!-- Updated HTML structure for better layout and styling -->
<div class="dialog-container">
  <!-- Header -->
  <div class="dialog-header">
    <div class="user-edit-icon">
      <img src="assets/images/user-circle.png" class="dialog-icon" alt="User Icon" />
    </div>
    <h2 class="dialog-title">Edit Health Info</h2>
    <button mat-icon-button type="button" (click)="onCancel()" class="close-button" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="healthForm" class="dialog-form" (ngSubmit)="onSave()">
    <div class="dialog-body">

      <!-- Height / Weight -->
      <div class="form-row">
        <div class="form-col">
          <label class="field-label">Height</label>
          <div class="input-unit">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field value-field">
              <input matInput type="number" [attr.min]="heightMin" [attr.max]="heightMax" step="any" formControlName="height"
                     (input)="onNumberInput($event, 'height')" />
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field unit-field">
              <mat-select formControlName="heightUnit" aria-label="Height unit">
                <mat-option value="cm">cm</mat-option>
                <mat-option value="inch">inch</mat-option>
                <mat-option value="feet">feet</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <mat-error class="field-error" *ngIf="getError('height') as err">{{ err }}</mat-error>
        </div>

        <div class="form-col">
          <label class="field-label">Weight</label>
          <div class="input-unit">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field value-field">
              <input matInput type="number" [attr.min]="weightMin" [attr.max]="weightMax" step="any" formControlName="weight"
                     (input)="onNumberInput($event, 'weight')" />
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field unit-field">
              <mat-select formControlName="weigthtUnit" aria-label="Weight unit">
                <mat-option value="kg">kg</mat-option>
                <mat-option value="lbs">lbs</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <mat-error class="field-error" *ngIf="getError('weight') as err">{{ err }}</mat-error>
        </div>
      </div>

      <!-- Blood Group / DOB -->
      <div class="form-row">
        <div class="form-col">
          <label class="field-label">Blood Group</label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field">
            <mat-select formControlName="bloodGroup" placeholder="Select blood group">
              <mat-option *ngFor="let group of bloodGroups" [value]="group.title">{{ group.title }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-error class="field-error" *ngIf="getError('bloodGroup') as err">{{ err }}</mat-error>
        </div>

        <div class="form-col">
          <label class="field-label">Date of Birth</label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field">
            <input matInput [matDatepicker]="picker" [max]="maxDate" formControlName="dob"
                   readonly (click)="picker.open()" placeholder="Select date" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-error class="field-error" *ngIf="getError('dob') as err">{{ err }}</mat-error>
        </div>
      </div>

      <!-- Gender / Ethnicity -->
      <div class="form-row">
        <div class="form-col">
          <label class="field-label">Gender</label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field">
            <mat-select formControlName="gender" placeholder="Select gender">
              <mat-option *ngFor="let option of gender_list" [value]="option">{{ option }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-error class="field-error" *ngIf="getError('gender') as err">{{ err }}</mat-error>
        </div>

        <div class="form-col">
          <label class="field-label">Ethnicity</label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field">
            <mat-select formControlName="ethnicity" placeholder="Select ethnicity">
              <mat-option *ngFor="let option of ethnicities" [value]="option.title">{{ option.title }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-error class="field-error" *ngIf="getError('ethnicity') as err">{{ err }}</mat-error>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="dialog-actions">
      <button mat-stroked-button type="button" class="btn-cancel" (click)="onCancel()">Cancel</button>
      <button mat-flat-button type="submit" class="btn-save" [disabled]="isSaving || !profileReady">{{ isSaving ? 'Saving…' : 'Save Changes' }}</button>
    </div>
  </form>
</div>